import { useMemo } from 'react';
import useReduxStateMarket from '@/pages/Market/hooks/useReduxStateMarkets';
import { findKey } from 'lodash';
import useIndustriesFetch from '@/pages/Market/hooks/useIndustriesFetch';

interface Industry {
  id: number;
  label: string;
}

export default function (): [Industry, boolean?] {
  const { market = 'us', sector, secondary, tertiary } = useReduxStateMarket();
  const { industries, isIndustriesFetched: isFetched } = useIndustriesFetch(
    market,
    false
  );
  return useMemo(() => {
    if (tertiary && industries.tertiary) {
      const id = findKey(industries.tertiary, ['slug', tertiary]);
      if (id) {
        return [
          {
            id: Number(id),
            label: industries.tertiary[id].label,
          },
          isFetched,
        ];
      }
    }
    if (secondary && industries.secondary) {
      const id = findKey(industries.secondary, ['slug', secondary]);
      if (id) {
        return [
          {
            id: Number(id),
            label: industries.secondary[id].label,
          },
          isFetched,
        ];
      }
    }
    if (sector && industries.sector) {
      const id = findKey(industries.sector, ['slug', sector]);
      if (id) {
        return [
          {
            id: Number(id),
            label: industries.sector[id].label,
          },
          isFetched,
        ];
      }
    }
    return [{ id: 0, label: '' }, isFetched];
  }, [tertiary, industries, secondary, sector, isFetched]);
}
